import {Box} from '@mui/material';
import DashboardStaffStation from './StationMgmt';
import IconStation from '../../../../../asset/icons/icon_station_management.svg';
import Header from '../../../../../components/header/Header';
import AdminHeaderCard from '../../../../admin/AdminHeaderCard';

const StationManagementPage = () => {
  return (
    <Box className='px-6 h-full'>
      <Header IconMessage={IconStation} Title='Station Management' />
      <Box className='calcheight-85'>
        <AdminHeaderCard
          child={<DashboardStaffStation />}
          title='Station Management'
        />
      </Box>
    </Box>
  );
};

export default StationManagementPage;
